var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcOnboardingMessengerFontSize(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icOnboardingMessengerFontSize") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 50 50 50 50 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 50 50 50 50 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Messenger-Plus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "What\\u2019s-new-in-messenger-popup",
    transform: "translate(-410.000000, -536.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(368.000000, 81.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(25.000000, 203.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, 230.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icOnboardingMessengerFontSize",
    transform: "translate(17.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1887",
    transform: "translate(25.000000, 25.000000) scale(-1, 1) rotate(-180.000000) translate(-25.000000, -25.000000) "
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1891-Clipped",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path1893"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1891",
    mask: "url(#mask-2)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.464844, 15.162109)",
    id: "Group-4",
    stroke: "#333333",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "path1899",
    points: "0 9.83789062 0 12.7675781 11.71875 12.7675781 11.71875 9.83789062"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.31054687,
    y1: 12.7675781,
    x2: 6.31054687,
    y2: 1.04882812,
    id: "path1903"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.9296875,
    y1: 0.5,
    x2: 9.53515625,
    y2: 0.5,
    id: "path1915"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1901",
    transform: "translate(7.275391, 16.210938)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1913",
    transform: "translate(4.394531, 15.162109)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1917",
    transform: "translate(16.210938, 15.162109)",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "path1919",
    points: "0 18.6269531 0 21.5566406 14.6484375 21.5566406 14.6484375 18.6269531"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.77539062,
    y1: 21.5566406,
    x2: 7.77539062,
    y2: 1.04882812,
    id: "path1923"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.39453125,
    y1: 0.5,
    x2: 10.7890625,
    y2: 0.5,
    id: "path1927"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1921",
    transform: "translate(23.486328, 16.210938)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1925",
    transform: "translate(20.605469, 15.162109)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1931",
    transform: "translate(30.957031, 15.162109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1937",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "path1939",
    points: "5.68434189e-14 27.4160156 5.68434189e-14 30.3457031 17.578125 30.3457031 17.578125 27.4160156"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.24023438,
    y1: 30.3457031,
    x2: 9.24023438,
    y2: 1.04882812,
    id: "path1943"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.859375,
    y1: 0.5,
    x2: 12.2429687,
    y2: 0.5,
    id: "path1947"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1941",
    transform: "translate(8.740234, 1.048828)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1945",
    transform: "translate(36.816406, 15.162109)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1951-Clipped",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path1953"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1951",
    mask: "url(#mask-4)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.416016, 4.492188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1957"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 5.859375,
    x2: 0.5,
    y2: 0,
    id: "path1959",
    stroke: "#333333",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1961",
    transform: "translate(48.070312, 0.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 5.859375,
    x2: 0.5,
    y2: 0,
    id: "path1963",
    stroke: "#333333",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1965",
    transform: "translate(1.048828, 2.880859)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0.5,
    x2: 47.0703125,
    y2: 0.5,
    id: "path1967",
    stroke: "#333333",
    strokeWidth: 1.5
  }))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOnboardingMessengerFontSize);
export default __webpack_public_path__ + "static/media/icOnboardingMessengerFontSize.16a3ba1f4c38e42213d4e098e8c8fe76.svg";
export { ForwardRef as ReactComponent };